import React from 'react';
import PropTypes from 'prop-types';
import { addModifiers } from '../../shared/helpers';

const Container = ({ children, modifiers = [] }) => (
  <div className={addModifiers('o-container', modifiers)}>{children}</div>
);

Container.propTypes = {
  children: PropTypes.node,
  modifiers: PropTypes.string,
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container/Container.js